/**
 * GeChiUI dependencies
 */
import { __ } from '@gechiui/i18n';
import { ToolbarButton } from '@gechiui/components';
import { fullscreen } from '@gechiui/icons';

function BlockFullHeightAlignmentControl( {
	isActive,
	label = __( 'Toggle full height' ),
	onToggle,
	isDisabled,
} ) {
	return (
		<ToolbarButton
			isActive={ isActive }
			icon={ fullscreen }
			label={ label }
			onClick={ () => onToggle( ! isActive ) }
			disabled={ isDisabled }
		/>
	);
}

export default BlockFullHeightAlignmentControl;
